export enum FieldType {
  shortText = 'shortText',
  paragraph = 'paragraph',
  richText = 'richText',
  date = 'date',
  dateTime = 'dateTime',
  checkbox = 'checkbox',
  radio = 'radio',
  singleSelect = 'singleSelect',
  multiSelect = 'multiSelect',
  slider = 'slider',
  list = 'list',
  color = 'color',
  score = 'score',
  hidden = 'hidden',

  contentHeader = 'contentHeader',
  contentSubHeader = 'contentSubHeader',
  contentParagraph = 'contentParagraph',
  contentImage = 'contentImage',
}

export default FieldType;
